import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import VariantReader from "aldoo-ra/VariantReader"
import DynamicSVG from "../DynamicSVG"
import { imageProps } from "aldoo-ra/CMS/url"
import { twMerge } from "tailwind-merge"

const Image = ({
  id,
  variant = "md",
  styleOverrides,
  recolor = false,
  className = "",
  alt = "icon",
  // img sizes attribute — enables responsive ?size= variants for raster images
  sizes,
}) => {
  // Get variant class from VariantReader
  const variantClass = VariantReader.useVariant({
    componentName: "Image",
    variant,
    styleOverrides,
  })

  // Use twMerge to combine classes
  const finalClassName = twMerge(variantClass, className)

  return (
    <CMSRender
      contentType="Image"
      match={{ "content.id": id }}
      page={1}
      itemsPerPage={1}
      renderItem={(icon) => {
        const isSVG = icon.image?.includes?.(".svg") || false
        return isSVG ? (
          <DynamicSVG
            url={icon.image}
            alt={icon.title || alt}
            recolor={recolor}
            className={finalClassName}
          />
        ) : (
          <img
            {...imageProps(icon.image, sizes)}
            alt={icon.title || alt}
            className={finalClassName}
          />
        )
      }}
    />
  )
}

export default Image
